// import axios from "axios";
import customAxios from "../../utils/customAxios";
import {
  BUSINESS_USER_ERROR,
  GET_BUSINESS_USERS,
  INDIVIDUAL_USER_ERROR,
  GET_INDIVIDUAL_USERS,
} from "../types";

export const getBusinessUsers = (queryParams) => async (dispatch) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString();
    const res = await customAxios.get(`/api/users?${queryString}`);
    dispatch({
      type: GET_BUSINESS_USERS,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: BUSINESS_USER_ERROR,
    });
  }
};

export const getIndividualUsers = (queryParams) => async (dispatch) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString();
    const res = await customAxios.get(`/api/users?${queryString}`);
    dispatch({
      type: GET_INDIVIDUAL_USERS,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: INDIVIDUAL_USER_ERROR,
    });
  }
};

export const updateUserPaymentSetting = async (id, reqBody, dispatch) => {
  try {
    const res = await customAxios.post(`/api/users/payment-setting/${id}`, reqBody);

    if (res.data.data.role === "business") {
      dispatch(getBusinessUsers({
        sortBy: "asc",
        orderBy: "date",
        page: 1,
        limit: 1,
        disableCalculateTotal: false,
        draw: 1,
        id: id,
      }))
    } else if (res.data.data.role === "individual") {
      dispatch(getIndividualUsers({
        sortBy: "asc",
        orderBy: "date",
        page: 1,
        limit: 1,
        disableCalculateTotal: false,
        draw: 1,
        id: id,
      }))
    }

    return res.data;
  } catch (error) {
    return error.response?.data ?? { code: 500, desc: "ERROR" };
  }
};

// Reloads the business user shown on the admin detail page so its status
// badge and buttons reflect the change that was just made.
const refreshBusinessUserDetail = (businessUserId, dispatch) => {
  dispatch(getBusinessUsers({
    sortBy: "asc",
    orderBy: "date",
    page: 1,
    limit: 1,
    disableCalculateTotal: false,
    draw: 1,
    id: businessUserId,
  }));
};

// Shared by approve / reject / deactivate. Always resolves to the API's
// { status, statusCode, data, message } shape, even when the request fails
// before reaching the server (no `error.response`), so callers can simply
// check `response.status === "success"`.
const postBusinessAccountAction = async (businessUserId, actionName, requestBody, dispatch) => {
  try {
    const res = await customAxios.post(
      `/api/admin/users/business/${businessUserId}/${actionName}`,
      requestBody
    );
    refreshBusinessUserDetail(businessUserId, dispatch);
    return res.data;
  } catch (error) {
    return error.response?.data ?? {
      status: "error",
      statusCode: 500,
      message: "Could not reach the server. Please try again.",
    };
  }
};

// paymentSetting: { iataEligible, iataDiscount, deferredPaymentEligible }
export const approveBusinessAccount = (businessUserId, paymentSetting, dispatch) =>
  postBusinessAccountAction(businessUserId, "approve", paymentSetting, dispatch);

export const rejectBusinessAccount = (businessUserId, dispatch) =>
  postBusinessAccountAction(businessUserId, "reject", {}, dispatch);

export const deactivateBusinessAccount = (businessUserId, dispatch) =>
  postBusinessAccountAction(businessUserId, "deactivate", {}, dispatch);